module.exports = __webpack_public_path__ + "static/img/legend_xa_english_vertical.b80f538.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/legend_xa_english_vertical.png
// module id = 67TI
// module chunks = 79